import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Typography } from '@material-ui/core';
import { makeStyles, lighten } from '@material-ui/core/styles';
import AddCircle from '@material-ui/icons/AddCircle';

import { Alert } from 'components';
import { GroupCreate } from 'Links';

interface IProps {
  total: number;
  checkedTotal: number;
  onAction: () => void;
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: `16px 24px`,
  },
  deleteButton: {
    minWidth: 150,
    borderColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: lighten(theme.palette.error.main, 0.9),
    },
  },
}));

const Header: FC<IProps> = props => {
  const { onAction, total, checkedTotal } = props;
  const classes = useStyles();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const { t } = useTranslation();

  function renderTotal() {
    return <Typography variant="subtitle2">{t('components:xGroup', { count: total })}</Typography>;
  }

  function renderConfirmation() {
    return (
      <Alert
        open={confirmOpen}
        onConfirm={() => {
          onAction();
          setConfirmOpen(false);
        }}
        onCancel={() => setConfirmOpen(false)}
        message={t('admin:deleteGroupMessage', { count: checkedTotal })}
        confirm={t('common:delete')}
      />
    );
  }

  return (
    <div className={classes.root}>
      <Grid container alignItems="center">
        <Grid item xs>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <Typography variant="subtitle2">{t('admin:allGroups')}</Typography>
            </Grid>
            {!!checkedTotal && (
              <Grid item>
                <Button
                  variant="outlined"
                  className={classes.deleteButton}
                  onClick={() => setConfirmOpen(true)}
                >
                  {t('common:delete')}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignItems="center" justify="flex-end" spacing={5}>
            <Grid item>{!!total && renderTotal()}</Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                component={GroupCreate}
                startIcon={<AddCircle />}
              >
                {t('components:newGroup')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {renderConfirmation()}
    </div>
  );
};

export default Header;
